import { getRequest } from '@/utils/request.js'

export function getDicts(dictType) {
  return getRequest(`/system/dict/data/type/${dictType}`)
}
